import styled from 'styled-components';
import { grid, GridProps } from 'styled-system';

export const Container = styled.div<GridProps>`
  display: grid;
  align-items: center;

  ${grid};
`;
